import { gql } from '@apollo/client';

import REFUNDS_FEE from './REFUNDS_FEE';
import REFUNDS_PRODUCT from './REFUNDS_PRODUCT';

export default gql`
  fragment RefundsLeg on Leg {
    direction
    trainNumber
    id
    isSummatedFare
    classOfService {
      code
      name
    }
    origin {
      name
      uic
      shortCode
      timezone
      countryCode
    }
    destination {
      name
      uic
      shortCode
      countryCode
    }
    fees {
      ...RefundsFee
    }
    feeProducts {
      passengerId
      code
      tariffDetails {
        tariffCode
      }
    }
    timing {
      isoDate
      date
      departs
      arrives
    }

    seats {
      coach
      number
      passenger {
        id
      }
    }

    meals {
      code
      passenger {
        id
      }
      price
      name
    }

    addOnLeg {
      trainNumber
      id
      name
      classOfService {
        code
        name
      }
      origin {
        name
        uic
        shortCode
        timezone
        isPseudoStation
      }
      destination {
        name
        uic
        shortCode
      }
      fees {
        ...RefundsFee
      }
      timing {
        isoDate
        date
        departs
        arrives
      }

      products {
        ...RefundsProduct
      }

      bookingItems @client {
        ...RefundsProduct
      }
    }

    sumOfProvisionalFees @client
    provisionalFees @client {
      ...RefundsFee
    }

    products {
      # This is required for bookingItems resolver
      ...RefundsProduct
    }

    bookingItems @client {
      ...RefundsProduct
      mealCode
      status
    }

    meals {
      code
      passenger {
        id
      }
      price
      name
    }

    refundSummaries @client {
      name
      passengerType
      code
      total
      quantity
      price
    }
    extraProducts {
      itemRef
      code
      name
      price
      priceWithCurrency
      currency
      isCancelled
      isPendingCancellation
      provisional
      type
      passenger {
        id
        firstName
        lastName
      }
    }
    serviceType {
      code
      name
    }
  }

  ${REFUNDS_FEE}
  ${REFUNDS_PRODUCT}
`;
